import { Box } from "@chakra-ui/react";
import { colors, getCdnImageSrc, HStack } from "goi_common";

export const SangjoNameLogo = ({ sangjo }: any) => {
  return (
    <HStack gap={8} alignItems="center">
      {sangjo?.id ? (
        <Box
          width="22px"
          height="22px"
          borderRadius="5px"
          backgroundImage={getCdnImageSrc(`platform/sangjos/${sangjo.id}/logo-background.png`)}
          backgroundSize="cover"
        />
      ) : (
        <Box width="22px" height="22px" borderRadius="5px" backgroundColor={colors.gray200} />
      )}
      <div className="caption_12_sb gray500">{sangjo?.name || "???"}</div>
    </HStack>
  );
};
